<template>
<!-- Modal เพิ่มกลุ่ม -->
<div class="modal fade" id="addGroupModal" tabindex="-1" aria-labelledby="addGroupModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">เพิ่มกลุ่มใหม่</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="px-2">
                    <div class="">
                        <div class="row g-4">
                            <!-- Left Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-info-circle me-2"></i>รายละเอียดกลุ่มผู้ใช้งาน
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-tag me-2"></i>ชื่อกลุ่ม
                                        </label>
                                        <input type="text" class="custom-input" placeholder="กรอกชื่อกลุ่มผู้ใช้งาน..." v-model="name">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-unlock me-2"></i>ระดับการเข้าถึงของกลุ่ม
                                        </label>
                                        <div class="toggle-wrapper">
                                            <select class="custom-input" v-model="planall">
                                                <option :value="true">All Plans Accessible</option>
                                                <option :value="false">Limited Access</option>
                                            </select>
                                        </div>
                                        <small class="form-text">
                                            <i class="bi bi-info-circle-fill me-1"></i>
                                            {{ planall ? 'Group members can access all available plans' : 'Group members have restricted plan access' }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-pencil-square me-2"></i>รายละเอียดเพิ่มเติม
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-chat-left-text me-2"></i>รายละเอียดกลุ่ม
                                        </label>
                                        <textarea class="custom-input" rows="8" placeholder="รายละเอียดกลุ่ม..." v-model="description"></textarea>
                                        <small class="form-text">
                                            คำอธิบายวัตถุประสงค์และขอบเขตของกลุ่มนี้
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="button-row mt-5">
                            <button @click="clearDataGroup()" class="btn-clear">
                                <i class="bi bi-arrow-counterclockwise me-2"></i>Clear Form
                            </button>
                            <button @click="createGroup()" class="btn-create" :disabled="!name">
                                <i class="bi bi-check-circle me-2"></i>Create Group
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal แก้ไขกลุ่ม -->
<div class="modal fade" id="editGroupModal" tabindex="-1" aria-labelledby="editGroupModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">แก้ไขกลุ่ม</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="px-2">
                    <div class="">
                        <div class="row g-4">
                            <!-- Left Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-info-circle me-2"></i>รายละเอียดกลุ่มผู้ใช้งาน
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-tag me-2"></i>ชื่อกลุ่ม
                                        </label>
                                        <input type="text" class="custom-input" placeholder="กรอกชื่อกลุ่มผู้ใช้งาน..." v-model="group.name">
                                    </div>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-unlock me-2"></i>ระดับการเข้าถึงของกลุ่ม
                                        </label>
                                        <div class="toggle-wrapper">
                                            <select class="custom-input" v-model="group.planall">
                                                <option :value="true">All Plans Accessible</option>
                                                <option :value="false">Limited Access</option>
                                            </select>
                                        </div>
                                        <small class="form-text">
                                            <i class="bi bi-info-circle-fill me-1"></i>
                                            {{ group.planall ? 'Group members can access all available plans' : 'Group members have restricted plan access' }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Section -->
                            <div class="col-lg-6">
                                <div class="form-section">
                                    <h5 class="section-title mb-4">
                                        <i class="bi bi-pencil-square me-2"></i>รายละเอียดเพิ่มเติม
                                    </h5>

                                    <div class="mb-4">
                                        <label class="custom-label">
                                            <i class="bi bi-chat-left-text me-2"></i>รายละเอียดกลุ่ม
                                        </label>
                                        <textarea class="custom-input" rows="8" placeholder="รายละเอียดกลุ่ม..." v-model="group.description"></textarea>
                                        <small class="form-text">
                                            คำอธิบายวัตถุประสงค์และขอบเขตของกลุ่มนี้
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="button-row mt-5">
                            <button type="button" class="btn-clear" data-bs-dismiss="modal">
                                <i class="bi bi-x-circle me-2"></i>ยกเลิก
                            </button>
                            <button @click="saveEditGroup()" class="btn-create" :disabled="!group.name">
                                <i class="bi bi-check-circle me-2"></i>บันทึกการแก้ไข
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="dashboard">
    <!-- Header -->
    <header class="header">
        <div class="container">
            <div class="header-content">
                <h1>กลุ่มผู้ใช้งาน</h1>

                <div class="search-box">
                    <button type="button" class="btn btn-dark px-3 rounded-5" data-bs-toggle="modal" data-bs-target="#addGroupModal"> + เพิ่มกลุ่ม</button>
                </div>

            </div>
        </div>
    </header>

    <!-- Main Content -->
    <div class="container main-content">
        <!-- Customers Table -->
        <div class="customers-section">
            <div class="section-header">
                <div class="col-12">
                    <div class="" style="font-size: 20px;">กลุ่มผู้ใช้งาน</div>
                    <div class="row mt-2">
                        <div class="col-6">
                            <div class="search-box">
                                <i class="bi bi-search"></i>
                                <input v-model.trim="q" @keyup.enter="reload" type="search" class="form-control" placeholder="ค้นหาชื่อกลุ่ม (กด Enter)" style="max-width: 260px; min-width: 200px;" />
                            </div>
                        </div>
                        <div class="col-6  ">
                            <div class="row justify-content-end align-items-center me-2">
                                <select v-model.number="size" class="form-select col-6" style="width: 120px;">
                                    <option :value="10">10 / หน้า</option>
                                    <option :value="20">20 / หน้า</option>
                                    <option :value="50">50 / หน้า</option>
                                </select>

                                <button class="btn btn-outline-dark col-2 ms-2" :disabled="loading" @click="reload">
                                    {{ loading ? "กำลังโหลด..." : "รีเฟรช" }}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-wrapper">
                <table class="customers-table">
                    <thead>
                        <tr>
                            <th>ลำดับ</th>
                            <th style="min-width: 220px;">ชื่อกลุ่ม</th>
                            <th>คำอธิบาย</th>
                            <th>รายละเอียด</th>
                            <th>แก้ไข/ลบ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(itemgroup, index) in list_group" :key="index">
                            <td class="">{{ index+1 }}</td>
                            <td>{{ itemgroup.name }}</td>
                            <td>{{ itemgroup.description || "-" }}</td>
                            <td class="text-start">
                                <router-link class="btn text-white py-1 px-3 " style="background-color: black; font-size: 14px;" :to="{ name:'group-plan', params:{ id:itemgroup.id, name: encodeURIComponent(itemgroup.name||'') } }">
                                    อุปกรณ์ในกลุ่ม
                                </router-link>

                                <router-link class="btn text-dark border py-1 px-3  ms-1" style="background-color: white; font-size: 14px;" :to="{ name:'group-user', params:{ id:itemgroup.id, name: encodeURIComponent(itemgroup.name||'') } }">
                                    รายชื่อผู้ใช้งานในกลุ่ม
                                </router-link>
                            </td>
                            <td>
                                <span @click="openEdit(itemgroup)" class="edit_btn px-1 py-1 rounded-2" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#editGroupModal">
                                    <i class="bi bi-pen"></i> แก้ไข
                                </span>
                                <span @click="deleteGroup(itemgroup.id)" class="remove_btn px-3 py-1 rounded-2 ms-2" style="cursor: pointer;">
                                    <i class="bi bi-trash3"></i> ลบ
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pagination">
                <div class="pagination-info">
                    Showing data 1 to 8 of 256K entries
                </div>
                <div class="pagination-controls">
                    <button class="page-btn" @click="prevPage" :disabled="currentPage === 1">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <button v-for="page in visiblePages" :key="page" :class="['page-btn', { active: currentPage === page }]" @click="currentPage = page">
                        {{ page }}
                    </button>
                    <button class="page-btn" v-if="totalPages > 5">...</button>
                    <button class="page-btn" @click="currentPage = 40">40</button>
                    <button class="page-btn" @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>


<script>
import * as bootstrap from 'bootstrap';
export default {
    data() {
        return {
            name: "",
            planall: false,
            description: "",
            // ตาราง
            list_group: [],
            loading: false,
            q: "",
            page: 1,
            size: 10,
            total: 0,

            // modal edit group
            group: {},
        };
    },
    computed: {
        disableNext() {
            return this.page * this.size >= this.total;
        },
        currentPage() {
            return this.page;
        },
        totalPages() {
            return Math.ceil(this.total / this.size);
        },
        visiblePages() {
            const pages = [];
            const start = Math.max(1, this.currentPage - 2);
            const end = Math.min(this.totalPages, start + 4);
            for (let i = start; i <= end; i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        async clearDataGroup() {
            this.name = "";
            this.planall = false;
            this.description = "";
        },
        async createGroup() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/group`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({
                        "name": this.name,
                        "description": this.description,
                        "planall": this.planall
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                
                // ปิด modal
                const modalElement = document.getElementById('addGroupModal');
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }
                
                // Clear form
                this.clearDataGroup();
                
                // Reload data
                this.getAllDevice();
                
                alert('เพิ่มกลุ่มสำเร็จ');
                console.log('Group created:', result);
            } catch (error) {
                console.error('Error creating group:', error);
                alert('เกิดข้อผิดพลาดในการเพิ่มกลุ่ม');
            }
        },
        /* ---------- API helpers ---------- */
        authHeaders(json = true) {
            const token = localStorage.getItem("accessToken");
            const h = json ? {
                "Content-Type": "application/json"
            } : {};
            return token ? {
                ...h,
                Authorization: `Bearer ${token}`
            } : h;
        },

        /* ---------- Groups list ---------- */
        async getAllDevice() {
            try {
                this.loading = true;
                const params = new URLSearchParams({
                    ...(this.q ? {
                        q: this.q
                    } : {}),
                    page: String(this.page),
                    size: String(this.size),
                });
                const res = await fetch(`${process.env.VUE_APP_API_URL}/api/groups?` + params.toString(), {
                    method: "GET",
                    headers: this.authHeaders(false),
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const json = await res.json();

                // map ฟิลด์ให้ตรง + fallback
                const rows = Array.isArray(json?.data) ? json.data : [];
                this.list_group = rows.map((g) => ({
                    ...g,
                    planall: g.planall ?? g.plansCount ?? 0,
                    member: g.member ?? g.usersCount ?? 0,
                    description: g.description ?? "",
                }));
                this.total = json?.meta?.total ?? this.list_group.length;
            } catch (e) {
                console.error("Error fetching groups:", e);
                this.list_group = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },
        reload() {
            this.page = 1;
            this.getAllDevice();
        },
        nextPage() {
            if (!this.disableNext) {
                this.page += 1;
                this.getAllDevice();
            }
        },
        prevPage() {
            if (this.page > 1) {
                this.page -= 1;
                this.getAllDevice();
            }
        },

        /* ---------- Edit Group modal ---------- */
        openEdit(row) {
            const clone = (o) => JSON.parse(JSON.stringify(o ?? {}));
            this.group = clone({
                id: row.id,
                name: row.name || "",
                description: row.description || "",
                planall: row.planall ?? false,
            });
        },
        async saveEditGroup() {
            try {
                const res = await fetch(`${process.env.VUE_APP_API_URL}/api/group/${this.group.id}`, {
                    method: "PUT",
                    headers: this.authHeaders(true),
                    body: JSON.stringify({
                        name: this.group.name,
                        planall: this.group.planall,
                        description: this.group.description,
                    }),
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                await res.json();

                // ปิด modal
                const modalElement = document.getElementById('editGroupModal');
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }

                // รีโหลดตาราง
                this.getAllDevice();
                
                // แสดงข้อความสำเร็จ
                alert('แก้ไขกลุ่มสำเร็จ');
            } catch (e) {
                console.error("Error edit group:", e);
                alert('เกิดข้อผิดพลาดในการแก้ไขกลุ่ม');
            }
        },
        async deleteGroup(id) {
            try {
                if (!confirm("แน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้? การลบจะไม่สามารถย้อนกลับได้")) return;
                
                const res = await fetch(`${process.env.VUE_APP_API_URL}/api/group/${id}`, {
                    method: "DELETE",
                    headers: this.authHeaders(false),
                });
                
                if (!res.ok) {
                    const errorData = await res.json();
                    throw new Error(errorData.message || `HTTP ${res.status}`);
                }
                
                // แสดงข้อความสำเร็จ
                alert('ลบกลุ่มสำเร็จ');
                
                // รีโหลดตาราง
                this.getAllDevice();
            } catch (e) {
                console.error("Error delete group:", e);
                alert('เกิดข้อผิดพลาดในการลบกลุ่ม: ' + e.message);
            }
        },

        clearForm() {
            this.group = {
                id: "",
                name: "",
                description: "",
                planall: false
            };
        },
    },
    watch: {
        size() {
            this.reload();
        },
    },
    mounted() {
        this.getAllDevice();
    },
};
</script>

<style scoped>
.edit_btn {
    background: #d4f4dd;
    color: #00ac4f;
    border: 1px solid #00ac4f;
}

.remove_btn {
    background: #ffe2e5;
    color: #fa5a7d;
    border: 1px solid #fa5a7d;
}

.dashboard {
    min-height: 100vh;
    background-color: #f5f6fa;
}

.header {
    background: white;
    padding: 20px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
    color: #1a1a1a;
}

.search-box {
    position: relative;
    width: 300px;
}

.search-box input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    background: #f9fafb;
    outline: none;
}

.search-box input:focus {
    border-color: #6366f1;
}

.search-box i {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
}

.main-content {
    padding-top: 40px;
    padding-bottom: 40px;
}

.customers-section {
    background: white;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.section-title {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px 0;
}

.table-wrapper {
    overflow-x: auto;
}

.customers-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.customers-table thead th {
    padding: 12px 16px;
    text-align: left;
    font-size: 14px;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #e5e7eb;
}

.customers-table tbody td {
    padding: 16px;
    font-size: 14px;
    color: #1a1a1a;
    border-bottom: 1px solid #f3f4f6;
}

.customers-table tbody tr:hover {
    background: #f9fafb;
}

.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e5e7eb;
}

.pagination-info {
    color: #9ca3af;
    font-size: 14px;
}

.pagination-controls {
    display: flex;
    gap: 8px;
}

.page-btn {
    width: 32px;
    height: 32px;
    border: 1px solid #e5e7eb;
    background: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    color: #6b7280;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    border-color: #6366f1;
    color: #6366f1;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-btn.active {
    background: #6366f1;
    color: white;
    border-color: #6366f1;
}

/* Modal Styles */
.form-section {
    height: 100%;
}

.section-title {
    color: #2d3748;
    font-weight: 600;
    font-size: 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #e2e8f0;
}

.custom-label {
    display: block;
    font-weight: 500;
    color: #4a5568;
    margin-bottom: 0.5rem;
    font-size: 0.95rem;
}

.custom-input {
    width: 100%;
    padding: 0.85rem 1rem;
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.95rem;
    transition: all 0.3s ease;
    background: #fafafa;
}

.custom-input:focus {
    outline: none;
    border-color: #667eea;
    background: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-input::placeholder {
    color: #a0aec0;
}

textarea.custom-input {
    resize: vertical;
    min-height: 120px;
}

select.custom-input {
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%234a5568' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;
    padding-right: 2.5rem;
}

.form-text {
    display: block;
    margin-top: 0.5rem;
    color: #718096;
    font-size: 0.85rem;
}

.button-row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    padding-top: 2rem;
    border-top: 2px solid #e2e8f0;
}

.btn-clear {
    padding: 0.85rem 2rem;
    border: 2px solid #e2e8f0;
    background: white;
    color: #718096;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
}

.btn-clear:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
    color: #2d3748;
    transform: translateY(-1px);
}

.btn-create {
    padding: 0.85rem 2.5rem;
    border: none;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-create:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.btn-create:disabled {
    background: #cbd5e0;
    cursor: not-allowed;
    box-shadow: none;
}

/* Responsive */
@media (max-width: 991px) {
    .button-row {
        flex-direction: column-reverse;
    }

    .btn-clear,
    .btn-create {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 768px) {
    .search-box {
        width: 100%;
    }

    .table-wrapper {
        overflow-x: scroll;
    }
}
</style>